"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryCodeByGEO = exports.COUNTRIES_CODES = void 0;
var _ = require("lodash");
var constants_1 = require("./constants");
Object.defineProperty(exports, "COUNTRIES_CODES", { enumerable: true, get: function () { return constants_1.COUNTRIES_CODES; } });
// KEY NOT UNIQUE!
var AVAILBLE_COUNTRY_CODES = Object.values(constants_1.COUNTRIES_CODES);
var getCountryCodeByGEO = function (geo) {
    if (_.isFinite(Number(geo))) {
        return AVAILBLE_COUNTRY_CODES.includes(geo) ? geo : undefined;
    }
    return constants_1.COUNTRIES_CODES[geo];
};
exports.getCountryCodeByGEO = getCountryCodeByGEO;
//# sourceMappingURL=index.js.map